<template>
	<!-- eslint-disable vue/no-v-html vue/no-v-text-v-html-on-component -->
	<component
		:is="as"
		class="app-translated-text-with-html"
		v-html="sanitizedTranslatedValue"
	/>
	<!-- eslint-enable vue/no-v-html vue/no-v-text-v-html-on-component -->
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { type Path } from 'vue-i18n';
import { useTranslation } from '@/composables';

/**
 * A helper component to make it easier to render translated text with some
 * HTML tags.
 *
 * @example
 * ```vue
 * <AppTranslatedTextWithHTML
 *   id="my_langvar_key"
 *   :values="{ foo: 1 }"
 * />
 * ```
 */

export type AppTranslatedTextWithHTMLProps = {
	id: Path;
	values?: Record<string, unknown>;
	as?: string;
};

const props = withDefaults(defineProps<AppTranslatedTextWithHTMLProps>(), {
	values: undefined,
	as: 'div',
});

const { sanitizedT } = useTranslation();

const sanitizedTranslatedValue = computed(() => {
	return sanitizedT(props.id, props.values);
});
</script>

<style lang="scss" scoped>
.app-translated-text-with-html {
	&:deep(a) {
		color: $blue-50;
	}
}
</style>
